import { AvatarColor, colorToThemeToClassName } from './Avatar';

// A simple hash function that maps a string to an integer between 0 and `max`
const simpleHash = (str: string, max: number): number => {
  let hash = 0;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);

    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + char;
    // eslint-disable-next-line no-bitwise
    hash &= hash; // Convert to 32bit integer
  }
  return Math.abs(hash) % max;
};

export const uuidToColor = (uuid: string): { color: AvatarColor } => {
  const colors = Object.keys(colorToThemeToClassName).filter(
    (color) => color !== 'gray',
  ) as unknown as AvatarColor[];

  const colorIndex = simpleHash(uuid, colors.length);

  const color = colors[colorIndex];

  return { color };
};

/**
 * Generates a string of initials from the given label by removing punctuation and spaces.
 * The resulting string is limited to a maximum number of characters specified by `maxChars`.
 *
 * @param {string} label - The input string from which initials are to be generated.
 * @param {number} maxChars - The maximum number of characters to include in the resulting initials.
 * @returns {string} A string of characters from the label, excluding spaces and punctuation, up to the maximum length specified.
 *
 * Example usage:
 *   makeInitials("Hello, World!", 3) would return "Hel"
 *   makeInitals("Foo , Bar", 2) would return "Fo"
 */
export const makeInitials = (label: string, maxChars: number): string => {
  const punctuation = new Set<string>([
    '.',
    ',',
    ';',
    ':',
    '!',
    '?',
    '"',
    "'",
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '-',
    '_',
  ]);
  let initials = '';

  // eslint-disable-next-line no-restricted-syntax
  for (const char of label) {
    if (!punctuation.has(char) && char !== ' ') {
      initials += char;
      if (initials.length === maxChars) {
        break;
      }
    }
  }

  return initials;
};
